import { render, staticRenderFns } from "./SolicitacoesEditar.vue?vue&type=template&id=40109648"
import script from "./SolicitacoesEditar.vue?vue&type=script&lang=js"
export * from "./SolicitacoesEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports